import { useEffect } from 'react';

export function BabelLoader() {
  useEffect(() => {
    // 检查是否已经加载
    if (typeof window !== 'undefined' && (window as any).Babel) {
      console.log('✅ Babel already loaded');
      return;
    }

    // 创建 script 标签加载本地 Babel
    const script = document.createElement('script');
    script.src = '/babel.min.js';
    script.async = false; // 确保在其他脚本之前加载

    script.onload = () => {
      if (typeof window !== 'undefined' && (window as any).Babel) {
        console.log('✅ Babel loaded from local file (no Tracking Prevention warning)');
      }
    };

    script.onerror = () => {
      // 如果本地文件加载失败，降级使用 CDN（会有 Tracking Prevention 警告）
      console.warn('⚠️ Failed to load local Babel, falling back to CDN');
      const fallbackScript = document.createElement('script');
      fallbackScript.src = 'https://unpkg.com/@babel/standalone@7.28.5/babel.min.js';
      document.head.appendChild(fallbackScript);
    };

    document.head.appendChild(script);

    // Cleanup（可选，通常不需要移除）
    return () => {
      // script.remove();
    };
  }, []);

  return null;
}
